// extracted by mini-css-extract-plugin
export default {"head":"TableheadAndRow_head__8djVs","row":"TableheadAndRow_row__TvhbZ","lastRow":"TableheadAndRow_lastRow__m+A0q","darkBlue":"TableheadAndRow_darkBlue__20QQv"};